import { Record, List } from 'immutable';
import { tFunctionType } from 'app/components/localization';
import { ALL_LANGUAGES } from 'app/constants/enums/Language';
import { LanguageId } from 'app/constants/enums/Language/data';

export enum WordOptionId {
  UsageQuestion = 'usage_questions',
}

export class WordOptionFilter<Id extends LanguageId | WordOptionId> {
  public constructor(
    public readonly id: Id,
    public readonly getName: (t: tFunctionType) => string,
  ) {}
}

export const USAGE_QUESTION = new WordOptionFilter(
  WordOptionId.UsageQuestion,
  (t) => t('admin.editor.word-options.usage-question'),
);

const LANGUAGE_FILTERS = ALL_LANGUAGES.map(({ id, getName }) => {
  return new WordOptionFilter(id, (t) => t('admin.editor.word-options.translation-label', { name: getName(t) }));
});

export const WORD_OPTION_FILTERS = List([
  USAGE_QUESTION,
  ...LANGUAGE_FILTERS,
]);

export const WORD_OPTION_FILTERS_MAP = Object.fromEntries(
  WORD_OPTION_FILTERS.map(f => [f.id, f]),
);

export class WordOptions extends Record<{[K in LanguageId | WordOptionId]: boolean | undefined }>(
  Object.fromEntries(
    WORD_OPTION_FILTERS.map(f => [f.id, undefined]),
  ),
) {}
